import { useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { allInterviewStatusOptions, basePath, currentDateAndTime, formatDate, interviewStatusOptions, isObject, isValidDateTillCurrent, validateFile, validateNumber, validatePhoneNumber } from '../Constants/constant';
import axios from 'axios';
import { AppContext } from '../ContextApi/ContextApi';
import Swal from 'sweetalert2';
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import { UpDownArrow } from '../Usables/IconButtons';
import BasicButton, { InterviewButton, RevertStatusButton } from '../Usables/Buttons';
import Dropdown from '../Usables/Dropdown';
import InterviewScheduleModal from '../Usables/interviewScheduleModal';
import InputField from '../Usables/InputField';
import Pagination from '../Usables/Pagination';
import PositionWiseData from '../Usables/PositionWiseData';
import Loader from '../Usables/Loader';
import NoRecords from '../Usables/NoRecords';
import { useLocation, useParams } from 'react-router-dom';
import EditCandidate from '../Usables/EditCandidate';
import JobPost from '../Jobs/JobPost';

// function useQuery() {
//     return new URLSearchParams(useLocation().search);
// }

const InterviewSchedule = ()=> {
    const { index } = useParams();
    // const query = useQuery();
    // const fromDateDas = query.get("fromDate");
    // const toDateDas = query.get("toDate");
    const { apiHeaderFile, apiHeaderJSON, user } = useContext(AppContext);
    const [loading, setLoading] = useState("1");
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [allInterviews, setAllInterviews] = useState([]);
    const [viewCandidate, setViewCandidate] = useState(false);
    const [candidateEdit, setCandidateEdit] = useState(false);
    const [isChange, setIsChange] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [interviewEdit, setInterviewEdit] = useState(false);
    const [candidateId, setCandidateId] = useState("");
    const [interviewStatus, setInterviewStatus] = useState("");
    const [positionWiseView, setPositionWiseView] = useState(false);
    const [positionWiseData, setPositionWiseData] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [usersOption, setUsersOption] = useState([]);
    const [jobFormModal, setJobFormModal] = useState(false);
    const [extraQuestions, setExtraQuestions] = useState([]);
    const [jobData, setJobData] = useState({});
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(false);
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [paginationPositionList, setPaginationPositionList] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [filterData, setFilterData] = useState({
        interview_done: "In Progress",
        orderBy: "scheduled_date",
        orderDirection: "DESC",
        isActive: true,
    });
    const [positionFilter, setPositionFilter] = useState({
        orderBy: "upload_date",
        orderDirection: "DESC",
        interview_status: "",
        isActive: true,
    });
    const [interviewModal, setInterviewModal] = useState(false);

    const getUserData = async () => {
        try {
            const options = {headers: apiHeaderJSON}
            const response = await axios.get(`${basePath}/getRecruiter`, options);
            // console.log(response.data);
            const recruiterList = response?.data?.map((val)=>{
                return {value: val?.id, label: val?.name, activated: val?.activated}
            });
            const listFilter = response?.data?.filter((val)=>{if(val?.activated === 1) return  val;});
            const activeList = listFilter?.map((val)=>{
                return {value: val?.id, label: val?.name, activated: val?.activated}
            });
            setAllUsers(recruiterList);
            setUsersOption(activeList);
        } catch (error) {
            toast.error("There is some server issue!!")
        }
    }

    const getList = useCallback(async()=> {
        try {
            setLoading(true);
            let res = await axios.get(`${basePath}/getinterview`,{
                params:{
                    limit:pagination?.limit,
                    page:pagination?.page,
                    id:localStorage.getItem("userId"),
                    filter:JSON.stringify(filterData)
                },
                headers:apiHeaderJSON
            });
            // console.log(res?.data?.Interview);
            setAllInterviews(res?.data?.Interview);
            setPagination({
                ...pagination,
                totalPages: res?.data?.pages,
                totalRecords: res?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.log(error);
        }
    },[filterData, pagination]);

    const handleInterviewSort = (columnName) => {
        if (filterData?.orderBy === columnName) {
            if (filterData?.orderDirection === "DESC") {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
        }
        setIsChanged({ ...isChanged, getListChanged: true });

    }
    const getPositionWiseData = useCallback(async()=> {
        try {
            const res = await axios.get(`${basePath}/getpositionwiseinterviewcandidatecount`,{
                params:{
                    limit:paginationPositionList?.limit,
                    page:paginationPositionList?.page,
                    id:localStorage.getItem("userId"),
                    filter:JSON.stringify(positionFilter)
                },
                headers:apiHeaderFile
            });
            const temp = res.data?.report?.filter((val) => {if (val?.interview_count) {return val;}});
            // console.log("+++++>>>>>getPositionWiseData ~ temp", temp);
            setPositionWiseData(temp);
            setPaginationPositionList({
                ...paginationPositionList,
                totalPages: res?.data?.pages,
                totalRecords: res?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
        // setRowData(sent);
    },[paginationPositionList, positionFilter]);

    const handleSort = (columnName) => {
        if (positionFilter?.orderBy === columnName) {
            if (positionFilter?.orderDirection === "DESC") {
                setPositionFilter({ ...positionFilter, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setPositionFilter({ ...positionFilter, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setPositionFilter({ ...positionFilter, orderBy: columnName, orderDirection: 'ASC' });
        }
    }
    
    useEffect(() => {
        setLoading("1");
        getList();        
        getUserData();        
    }, []);



    // updating candidate current application status
    const handleInterviewStatus = async () => {
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to chnage status to ${interviewStatus}!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
            input: 'textarea',
            inputLabel: 'Remark (Optional)',
            inputPlaceholder: 'Enter remark...',
            inputAttributes: {'aria-label': 'Enter Remark',},
        }).then((result) => {
            if (result.isConfirmed) {
            // console.log("============>>>>> candiate id", candidateId, interviewStatus);
            const data = {
                remarks: result?.value,
                interview_status: interviewStatus,
                recruiter_id: localStorage.getItem("userId"),
            }
            // console.log("interviewStatus========>>>>>>>", data);
            const options = {
                url: `${basePath}/updateinterviewstatus/${candidateId}`,
                method: "PATCH",
                headers: apiHeaderJSON,
                data,
            }
            axios(options)
            .then((response) => {
                if (response.status === 200) {
                    setLoading(false);
                    // console.log(response);
                    getList();
                    toast.success("Interview Status Updated Successfully");
                }
                else {
                    setLoading(false);
                    toast.error("Unable to Update");
                }
            })
            .catch((e) => {
                setLoading(false);
                if (e.response?.status === 404) {
                    toast.info(e.response?.data?.error);
                } else {
                    toast.error("Unable to Update");
                }

            });
        }})


    }
    const handleNextRound = async () => {
        const errorList = validateInterviewForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        // console.log("==========>>>>>>>>interviewScheduleData", interviewScheduleData, candidateId);
        Swal.fire({
        title: 'Are you sure?',
        text: 'You want to update interview schedule details!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Update!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30',
        cancelButtonColor: '#F44336',
        allowOutsideClick: false,
        input: 'textarea',
        inputLabel: 'Reason (required)',
        inputPlaceholder: 'Enter reason for revert...',
        inputAttributes: {'aria-label': 'Enter Reason',},
        }).then(async(result) => {
            if (result.isConfirmed) {
            try {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Updating Details...',
                    allowOutsideClick: false,
                    didOpen: () => {Swal.showLoading();}
                });
                const data = {
                    ...formData,
                    remarks: result.value,
                    interview_status: interviewStatus,
                    recruiter_id: localStorage.getItem("userId"),
                }
                // console.log("=====>>>>handleInterviewUpdate", data);
                const [response1, response2] = await Promise.allSettled([
                    await axios.patch(`${basePath}/updateinterviewdetails/${formData?.candidate_id}`, data, { headers: apiHeaderJSON }),
                    await axios.patch(`${basePath}/updateinterviewstatus/${formData?.candidate_id}`, data, { headers: apiHeaderJSON }),
                ]);

                if (response1.status === "fulfilled" && response2.status === "fulfilled") {
                    // console.log(response);
                    getList();
                    setInterviewStatus(false);
                    setInterviewModal(false);
                    setInterviewEdit(false);
                    setFormData({});
                    setErrors({});
                    Swal.close();
                    toast.success(response2?.data?.message || "Details Updated Successfully");
                }
                else if (response2.status === "fulfilled") {
                    getList();
                }
                else {
                    Swal.close();
                    toast.error( response2?.data?.error || "Unable to update Interview!");
                }
            } catch(error) {
                console.log(error);
                Swal.close();
                toast.error( error?.response?.data?.error || "Unable to update Interview!");
            };
            }
        });
    }

    const handleUpdate = async ()=> {
         const errorList = validateInterviewForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        Swal.fire({
        title: 'Are you sure?',
        text: 'You want to update interview schedule details!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Update!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30',
        cancelButtonColor: '#F44336',
        allowOutsideClick: false,
        }).then(async(result) => {
            if (result.isConfirmed) {
                 try {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Updating Details...',
                    allowOutsideClick: false,
                    didOpen: () => {Swal.showLoading();}
                });
                const data = {
                    ...formData,
                    recruiter_id: localStorage.getItem("userId"),
                }
                // console.log("=====>>>>handleInterviewUpdate", data);
                const response = await axios.patch(`${basePath}/updateinterviewdetails/${formData?.candidate_id}`, data, { headers: apiHeaderJSON });

                if (response.status === 200) {
                    // console.log(response);
                    getList();
                    setInterviewModal(false);
                    setInterviewStatus(false);
                    setInterviewModal(false);
                    setInterviewEdit(false);
                    setFormData({});
                    setErrors({});
                    Swal.close();
                    toast.success(response?.data?.message || "Details Updated Successfully.");
                }
                else {
                    Swal.close();
                    toast.error( response?.data?.error || "Unable to update Interview!");
                }
                    } catch(error) {
                        console.log(error);
                        Swal.close();
                        toast.error( error?.response?.data?.error || "Unable to update Interview!");
                    };
            }})
    }
    const handleSubmit = async ()=> {
        if (interviewStatus === "Shortlisted Next Round") handleNextRound();
        else handleUpdate();
    }
    const validateInterviewForm = ()=>{
            const errors = {};
            if (!formData?.interview_date || formData?.interview_date.trim() === "") {
                errors.interview_date = "Interview Date is required!";
                return errors;
            } 
            if (!formData?.interview_time || formData?.interview_time.trim() === "") {
                errors.interview_time = "Interview TIme is required!";
                return errors;
            }
            if (!formData?.interview_mode) {
                errors.interview_mode = "Interview Mode is required!";
                return errors;
            }
            if (!formData?.interview_location || formData?.interview_location.trim() === "") {
                errors.interview_location = "Interview Location is required!";
                return errors;
            }
            if (!formData?.contact_person_name || formData?.contact_person_name.trim() === "") {
                errors.contact_person_name = "Name is required!";
                return errors;
            } else if (formData?.contact_person_name && formData?.contact_person_name?.length < 3) {
                errors.contact_person_name = "Name must be at least 3 characters!";
                return errors;
            }
            // mobile number validation
            if (!formData?.phone_code && formData?.contact_person_mobile_number && !validatePhoneNumber("IN",formData?.contact_person_mobile_number)?.isValid) {
                errors.contact_person_mobile_number = validatePhoneNumber("IN",formData?.contact_person_mobile_number)?.message;
                return errors;
            }
            if (formData?.phone_code && formData?.contact_person_mobile_number) {
                const validateNum = validatePhoneNumber(formData?.phone_code, formData?.contact_person_mobile_number);
                if(!validateNum?.isValid && validateNum?.codeError) {
                    errors.phone_code = validateNum?.message;
                    return errors;
                }
                else if(!validateNum?.isValid && !validateNum?.codeError) {
                    errors.contact_person_mobile_number = validateNum?.message;
                    return errors;
                }
            }
            if (!formData?.phone_code && formData?.contact_person_mobile_number) {
                errors.phone_code = "Required!";
                return errors;
            }
            if (formData?.interview_remarks && formData?.interview_remarks?.length < 2) {
                errors.interview_remarks = "Remark must be at least 2 characters!";
                return errors;
            }
            
            return errors;
        }
    const handleRevertStatus = async (val) => {
        Swal.fire({
        title: 'Are you sure?',
        text: 'You want to revert status!',
        icon: 'warning',
        input: 'textarea',
        inputLabel: 'Reason (required)',
        inputPlaceholder: 'Enter reason for revert...',
        inputAttributes: {'aria-label': 'Enter Reason',},
        showCancelButton: true,
        confirmButtonText: 'Yes, Revert!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30',
        cancelButtonColor: '#F44336',
        allowOutsideClick: false,
        preConfirm: (remark) => {
            if (!remark || remark.trim() === '') {
            Swal.showValidationMessage('Reason is required');
            return false;
            }
            return remark;
        }}).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Sending Email...',
                    allowOutsideClick: false,
                    didOpen: () => {Swal.showLoading();}
                });
                const data = {remarks: result.value, candidate_id: val?.Candidate?.id}
                const options = {
                    url: `${basePath}/RevertCandidateStatus`,
                    method: "POST",
                    headers: apiHeaderJSON,
                    data,
                }
                axios(options).then((response) => {
                    if (response.status === 200) {
                        setLoading(false);
                        // console.log(response);
                        getList();
                        toast.success(response?.data?.message || "Candidate Status Updated Successfully");
                    }
                    else {
                        toast.error(response?.data?.message || "Unable to Update");
                    }
                    Swal.close();
                })
                .catch((e) => {
                    Swal.close();
                    console.log(e);
                    toast.error(e.response?.error || "There is some network error!! Please try again later.");
                });
            }})
    }

    // updating candidate personal details
    const handleCandidateSubmit = () => {
        // console.log("handleCandidateSubmit => formData =>",formData);
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to save!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
            setLoadingUpdate(true);
            const data = {
                ...formData,
                candidate_resume: null,
                recruiter_id: localStorage.getItem("userId")
            }
            if(isObject(formData?.candidate_resume)){
                data.candidate_resume = formData?.candidate_resume;
            }
            // console.log("=========:>>>>>> ", data);
            const options = {
                headers: {...apiHeaderFile},
            }
            axios.patch(`${basePath}/editatspipeline/${viewCandidate?.id}`,data, options)
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response);
                    handleClose();
                    getList();
                    setLoadingUpdate(false);
                    toast.success(response?.data?.message || "Updated Successfully");
                }
                else {
                    setLoadingUpdate(false);
                    toast.error(response?.data?.message || "Opps!! Something went wrong.");
                }
            })
            .catch((e) => {
                setLoadingUpdate(false);
                console.log(e);
                toast.error(e.response?.data?.message || "Internal server error!");
            });
        }})
    }
    const validateForm = ()=>{
        const errors = {};
        if (!formData?.candidate || formData?.candidate.trim() === "") {
            errors.candidate = "Candidate name is required!";
            return errors;
        } else if (formData?.candidate.length < 3) {
            errors.candidate = "Name must be at least 3 characters!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate)) {
            errors.candidate = "Name can only contain letters!";
            return errors;
        }
        // Email validation
        if (!formData?.candidate_email || formData?.candidate_email.trim() === "") {
            errors.candidate_email = "Email is required!";
            return errors;
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.candidate_email)
        ) {
            errors.candidate_email = "Invalid email address!";
            return errors;
        }

        // mobile number validation
        if (!formData?.phone_code || formData?.phone_code.trim() === "") {
            errors.phone_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_phone || formData?.candidate_phone.trim() === "") {
            errors.candidate_phone = "Mobile number is required!";
        } else if (formData?.phone_code && formData?.candidate_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_code, formData?.candidate_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_code = validateNum?.message;
                return errors;
            }
            else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_phone = validateNum?.message;
                return errors;
            }
        }
        
        if ((!formData?.phone_alt_code || formData?.phone_alt_code.trim() === "") && formData?.candidate_alt_phone) {
            errors.phone_alt_code = "Required!";
            return errors;
        }
        // if (!formData?.candidate_alt_phone || formData?.candidate_alt_phone.trim() === "") {
        //     errors.candidate_alt_phone = "Mobile number is required!";
        // }
        if (formData?.phone_alt_code && formData?.candidate_alt_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_alt_code, formData?.candidate_alt_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_alt_code = validateNum?.message;
                return errors;
            } else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_alt_phone = validateNum?.message;
                return errors;
            }
        }

        if (!formData?.candidate_location || formData?.candidate_location.trim() === "") {
            errors.candidate_location = "Candidate location is required!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate_location)) {
            errors.candidate_location = "Location can only contain letters!";
            return errors;
        }
        if (!formData?.candidate_qualification || formData?.candidate_qualification.trim() === "") {
            errors.candidate_qualification = "Qualification is required!";
            return errors;
        }
        if (!formData?.current_currency_code) {
            errors.current_currency_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_current_ctc || formData?.candidate_current_ctc.trim() === "") {
            errors.candidate_current_ctc = "Current CTC is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_current_ctc, 100000000)?.success) {
            errors.candidate_current_ctc = validateNumber(formData?.candidate_current_ctc, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_ectc_type) {
            errors.candidate_ectc_type = "Required!";
            return errors;
        }
        if (!formData?.expected_currency_code) {
            errors.expected_currency_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_expected_ctc || formData?.candidate_expected_ctc.trim() === "") {
            errors.candidate_expected_ctc = "Expected CTC is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_expected_ctc, 100000000)?.success) {
            errors.candidate_expected_ctc = validateNumber(formData?.candidate_expected_ctc, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_industry || formData?.candidate_industry.trim() === "") {
            errors.candidate_industry = "Industry is required!";
            return errors;
        }
        if (!formData?.candidate_experience || formData?.candidate_experience.trim() === "") {
            errors.candidate_experience = "Experience is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_experience, 50)?.success) {
            errors.candidate_experience = validateNumber(formData?.candidate_experience, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_notice_period) {
            errors.candidate_notice_period = "This field is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_notice_period, 500)?.success) {
            errors.candidate_notice_period = validateNumber(formData?.candidate_notice_period, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_gender || formData?.candidate_gender.trim() === "") {
            errors.candidate_gender = "This field is required!";
            return errors;
        }
        if (formData?.candidate_dob && !isValidDateTillCurrent(formData?.candidate_dob)) {
            errors.candidate_dob = "DOB should be less or equal to current year!";
            return errors;
        }
        if (formData?.candidate_resume && isObject(formData?.candidate_resume)){
            const valid = validateFile(formData?.candidate_resume, 5, ['application/pdf']);
            if (!valid?.valid) {
                errors.candidate_gender = valid?.message;
                return errors;
            }
        }       
            if(!validateMandatory()){
                errors.required = "Required!";
                return errors;
            }
        return errors;
    }
    // valiadte that is any questions answer is empty or not  
    const validateMandatory = () => {
        let isValid = true;

        const updatedQuestions = Array.isArray(formData?.position_questions) && formData?.position_questions.map(item => {
        if (item.is_mandatory === 1 && (!item.response_text || item.response_text.trim() === "")) {
            isValid = false;
            return { ...item, error_text: "This question is mandatory." };
        }
        return { ...item, error_text: "" };
        });

        setFormData(prev => ({
        ...prev,
        position_questions: updatedQuestions || [],
        }));

        return isValid;
    };

    const handleDownload = async () => {    
        try {
            const response = await fetch(`${basePath}/downloadresume/${formData?.id}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${formData?.candidate.replace(/ /g, "_")}_resume_${formatDate(new Date())}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
        } catch (error) {
            console.error('There is a problem with the download:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There is a problem with the download");
            }
        }
    }

    const handleStatusChange = (e,row) => {
        setCandidateId(row?.candidate_id);
        if (e.target.value === "Shortlisted Next Round") {
            setInterviewEdit(true);
            handleInterview(row,true);
            setInterviewModal(row);
            setInterviewStatus(e.target.value);
        }
        else {
            setInterviewStatus(e.target.value);
            setIsChange(true);
        }
    }

    useEffect(()=>{
        if(isChange){
            handleInterviewStatus();
            setIsChange(false);
        }
    },[isChange]);

    const handleRefresh = () => {
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }

    const handleRefreshPosition = () => {
        setLoading("2");
        getPositionWiseData();
    }

    const handleCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        const num = !checked ? 2 : 1;
        const all = allUsers?.filter((val)=>{if(val?.activated === num) return val;});
        setFilterData({ ...filterData, isActive: checked }); 
        setUsersOption(all);
    },[allUsers, filterData]);

    const handlePositionCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        const num = !checked ? 2 : 1;
        const all = allUsers?.filter((val)=>{if(val?.activated === num) return val;});
        setPositionFilter({ ...positionFilter, isActive: checked }); 
        setUsersOption(all);
    },[allUsers,positionFilter]);

    const handlePositionSelect = (e)=> {
        const { value } = e.target;
        setFilterData({
            ...filterData,
            company: value?.company_name,
            position: value?.position_name,
            fromDate: "",
            toDate: "",
            candidate: "",
            orderBy: "sourcing_date",
            orderDirection: "DESC"
        });
        setPositionWiseView(false);
        setIsChanged({ ...isChanged, getListChanged: true });
    }

    const handleChangeInput = useCallback((event, id)=> {
        const {name, value} = event?.target;
        if (name === "answer") {
        setFormData(prev => ({
            ...prev,
            position_questions: prev.position_questions.map(item =>
                item.question_id === id
                ? { ...item, response_text: value?.trim(), error_text: "" }
                : item
            )
        }));
    } else if (name === "current_currency_code") {
    setFormData({ ...formData, [name]: value?.trim(), expected_currency_code: value }); setErrors({...errors, [name]: "", expected_currency_code: ""});
    } else {setFormData({ ...formData, [name]: value?.trim(), }); setErrors({...errors, [name]: ""});}
    },[formData, errors]);

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilterData({ ...filterData, [name]: value, });
    },[filterData]);

    const handleChangePositionFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setPositionFilter({ ...positionFilter, [name]: value,});
    },[positionFilter]);

    const handleInterview = (row, isShortListed = false) => {
        // console.log("row", row);
        const round = isShortListed ? parseInt(row?.interview_round) + 1 : row?.interview_round;
        setFormData({
            scheduled_date: row?.scheduled_date || new Date().toISOString().split("T")[0],
            candidate_id: row?.candidate_id,
            candidate: row?.Candidate?.candidate,
            candidate_email: row?.Candidate?.candidate_email,
            interview_round: round,
            interview_mode: row?.interview_mode,
            interview_date: row?.interview_date,
            interview_time: row?.interview_time,
            interview_location: row?.interview_location,
            contact_person_name:row?.contact_person_name,
            phone_code: row?.phone_code,
            contact_person_mobile_number:row?.contact_person_number,
            interview_status: row?.interview_status,
            interview_remarks: row?.interview_remarks,
            interview_done: row?.interview_done,
        });
        setInterviewModal(row);
    }

    const handleClose = ()=> {
        setInterviewModal(false);
        setJobFormModal(false);
        setJobData(false);
        setPositionWiseView(false);
        setInterviewEdit(false);
        setViewCandidate(false);
        setCandidateEdit(false);
        setErrors({});
        setFormData({});
    }

    const handleCheckStatus = (value)=> {
        const statusList = [
        {name: "Rejected Post Interview", className: "text-red-500 redBox"},
        {name: "Backout", className: "text-red-700 redBox"},
        {name: "Final Selection", className: " text-green-700 bg-green-100"},
        {name:"Blacklist", className: "text-white bg-stone-900 rounded-lg"},
        ];
        return statusList.find(status => status?.name === value) || false;
    }

    const handleEditOn = ()=> {
        setInterviewEdit(true);
    }

    const handleCancelEdit = ()=> {
        setInterviewEdit(false);
        setFormData({
            scheduled_date: interviewModal?.scheduled_date || new Date().toISOString().split("T")[0],
            candidate_id: interviewModal?.candidate_id,
            candidate: interviewModal?.Candidate?.candidate,
            candidate_email: interviewModal?.Candidate?.candidate_email,
            interview_round: interviewModal?.interview_round,
            interview_mode: interviewModal?.interview_mode,
            interview_date: interviewModal?.interview_date,
            interview_time: interviewModal?.interview_time,
            interview_location: interviewModal?.interview_location,
            contact_person_name: interviewModal?.contact_person_name,
            phone_code: interviewModal?.phone_code,
            contact_person_mobile_number:interviewModal?.contact_person_number,
            interview_status: interviewModal?.interview_status,
            interview_remarks: interviewModal?.interview_remarks,
            interview_done: interviewModal?.interview_done,
        });
        setErrors({});
    }

    const handleFilter = () => {
        setLoadingFilter("1");
        getList();
    };

    const handleClear = ()=> {
        setLoadingFilter("2");
        setFilterData({
            fromDate: "", toDate: "",
            interview_round: "", interview_date: "",
            interview_status: "", interview_location: "",
            company: "", position: "", isActive: filterData?.isActive,
            candidate: "", interview_done: "In Progress",
            orderBy: "scheduled_date", orderDirection: "DESC",
        });
        setIsChanged({...isChanged, getListChanged: true});
    }

    useEffect(()=>{
        if (isChanged?.getListChanged) {
            getList();
            setIsChanged({...isChanged, getListChanged: false});
        }
    },[isChanged?.getListChanged]);

    useEffect(()=>{
        if (isChanged?.positionListChanged) {
            getList();
            setIsChanged({...isChanged, positionListChanged: false});
        }
    },[isChanged?.positionListChanged]);

    const handlePositionModal = ()=> {
        setLoading("3");
        getPositionWiseData(); 
        setPositionWiseView(true);
    }

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIsChanged({...isChanged, getListChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIsChanged({...isChanged, getListChanged: true});
        }
    }
    const handleNext = (e)=> {
        
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIsChanged({...isChanged, getListChanged: true});
        }
    }

    const handlePositionFilter = useCallback(() => {
        setLoadingFilter("3");
        getPositionWiseData();
    },[getPositionWiseData]);
        
    const handlePositionClear = useCallback(() => {
        setLoadingFilter("4");
        setPositionFilter({
            fromDate: "", toDate: "",
            company: "", position: "",
            orderBy: "upload_date", isActive: positionFilter?.isActive,
            recruiter: "", orderDirection: "DESC",
            status: "",
        });
        setFilterData({
            ...filterData,
            isActive: positionFilter?.isActive,
        });
        setIsChanged({...isChanged, positionListChanged: true, getListChanged:false})
    },[isChanged, positionFilter, filterData]);
    
    const handleLimitPositionList = (e)=> {
        setPaginationPositionList({...paginationPositionList, limit: e.target.value});
        setIsChanged({...isChanged, positionListChanged: true})
    }
    const handlePrevPositionList = (e)=> {
        // console.log("paginationPositionList?.totalPages > paginationPositionList?.page",paginationPositionList?.totalPages, paginationPositionList?.page)
        if (paginationPositionList?.page > 1) {
            setPaginationPositionList({...paginationPositionList, page: paginationPositionList?.page - 1});
            setIsChanged({...isChanged, positionListChanged: true})
        }
    }
    const handleNextPositionList = (e)=> {
        // console.log("paginationPositionList?.totalPages > paginationPositionList?.page",paginationPositionList?.totalPages, paginationPositionList?.page)
        if (paginationPositionList?.totalPages > paginationPositionList?.page) {
            setPaginationPositionList({...paginationPositionList, page: paginationPositionList?.page + 1});
            setIsChanged({...isChanged, positionListChanged: true})
        }
    }

     // handling edit button 
    const handleEdit = (val) => {
        // console.log("edit val =>", val);
        setFormData({
            id: val?.Candidate?.id,
            candidate: val?.Candidate?.candidate || "",
            candidate_email: val?.Candidate?.candidate_email || "",
            phone_code: val?.Candidate?.phone_code || "",
            candidate_phone: val?.Candidate?.candidate_phone || "",
            phone_alt_code: val?.Candidate?.phone_alt_code || "",
            candidate_alt_phone: val?.Candidate?.candidate_alt_phone || "",
            candidate_location: val?.Candidate?.candidate_location || "",
            candidate_qualification: val?.Candidate?.candidate_qualification || "",
            current_currency_code: val?.Candidate?.current_currency_code || "",
            candidate_current_ctc: val?.Candidate?.candidate_current_ctc || "",
            candidate_ectc_type: val?.Candidate?.candidate_ectc_type || "",
            expected_currency_code: val?.Candidate?.expected_currency_code || "",
            candidate_expected_ctc: val?.Candidate?.candidate_expected_ctc || "",
            candidate_dob: val?.Candidate?.candidate_dob || "",
            candidate_industry: val?.Candidate?.candidate_industry || "",
            candidate_organization: val?.Candidate?.candidate_organization || "",
            candidate_designation: val?.Candidate?.candidate_designation || "",
            candidate_experience: val?.Candidate?.candidate_experience || "",
            candidate_notice_period: val?.Candidate?.candidate_notice_period || "",
            candidate_gender: val?.Candidate?.candidate_gender || "",
            candidate_resume: val?.Candidate?.resume_link || "",
            position_questions: val?.Candidate?.CandidateQnAs || [],
            candidate_remarks: val?.Candidate?.candidate_remarks 
        });
        setViewCandidate(val)
    }
    const handleCancelCandidateEdit = () => {
        // console.log("edit val =>", viewCandidate);
        setFormData({
            id: viewCandidate?.Candidate?.id,
            candidate: viewCandidate?.Candidate?.candidate || "",
            candidate_email: viewCandidate?.Candidate?.candidate_email || "",
            phone_code: viewCandidate?.Candidate?.phone_code || "",
            candidate_phone: viewCandidate?.Candidate?.candidate_phone || "",
            phone_alt_code: viewCandidate?.Candidate?.phone_alt_code || "",
            candidate_alt_phone: viewCandidate?.Candidate?.candidate_alt_phone || "",
            candidate_location: viewCandidate?.Candidate?.candidate_location || "",
            candidate_qualification: viewCandidate?.Candidate?.candidate_qualification || "",
            current_currency_code: viewCandidate?.Candidate?.current_currency_code || "",
            candidate_current_ctc: viewCandidate?.Candidate?.candidate_current_ctc || "",
            candidate_ectc_type: viewCandidate?.Candidate?.candidate_ectc_type || "",
            expected_currency_code: viewCandidate?.Candidate?.expected_currency_code || "",
            candidate_expected_ctc: viewCandidate?.Candidate?.candidate_expected_ctc || "",
            candidate_dob: viewCandidate?.Candidate?.candidate_dob || "",
            candidate_industry: viewCandidate?.Candidate?.candidate_industry || "",
            candidate_organization: viewCandidate?.Candidate?.candidate_organization || "",
            candidate_designation: viewCandidate?.Candidate?.candidate_designation || "",
            candidate_experience: viewCandidate?.Candidate?.candidate_experience || "",
            candidate_notice_period: viewCandidate?.Candidate?.candidate_notice_period || "",
            candidate_gender: viewCandidate?.Candidate?.candidate_gender || "",
            candidate_resume: viewCandidate?.Candidate?.resume_link || "",
            position_questions: viewCandidate?.Candidate?.CandidateQnAs || [],
            candidate_remarks: viewCandidate?.Candidate?.candidate_remarks 
        });
        setViewCandidate(viewCandidate);
        setCandidateEdit(false);
    }

    const handleViewJob = (val) => {
        console.log('val ======================>>>>>>>>>');
        console.log('val',val);
        setJobData({
            id: val?.id,
            company: val?.Candidate?.Position?.Company?.id,
            position: val?.Candidate?.Position?.position,
            location: val?.Candidate?.Position?.location,
            min_experience: val?.Candidate?.Position?.min_experience,
            max_experience: val?.Candidate?.Position?.max_experience,
            currency_code: val?.Candidate?.Position?.currency_code,
            minCtc: val?.Candidate?.Position?.min_ctc,
            maxCtc: val?.Candidate?.Position?.max_ctc,
            min_age: val?.Candidate?.Position?.min_age,
            max_age: val?.Candidate?.Position?.max_age,
            no_of_positions: val?.Candidate?.Position?.no_of_positions,
            positon_industry: val?.Candidate?.Position?.positon_industry,
            gender_pref: val?.Candidate?.Position?.gender_pref,
            qualification: val?.Candidate?.Position?.qualification,
            description: val?.Candidate?.Position?.jd_upload,
            jd_upload: val?.Candidate?.Position?.jd_link
        });
         const mappedQuestions = val?.PositionQuestions?.map(q => ({
            question_id: q.question_id,           
            question: q.question_text || "",
            required: q.is_mandatory == 1,        
            type: "text",                     
        }));
        setExtraQuestions(mappedQuestions);
        setJobFormModal(val);
    }

    const handleExport = async () => {
        try {
            setLoadingFilter("3");
            Swal.fire({
                title: 'Please wait...',
                html: 'Your file is being prepared for download.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

                const options = {
                params: {
                    download:'yes',
                    filter: JSON.stringify(filterData),
                    page:pagination.page,
                    limit:pagination.limit
                },
                headers: apiHeaderJSON,
                responseType: 'blob',
            }
            const response = await axios.get(`${basePath}/getinterview`, options);

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Interview Candidates ${formatDate( currentDateAndTime())}.xlsx`);
            document.body.appendChild(link);
            link.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
            setLoadingFilter(false);
            toast.success("Excel Exported Successfully!");
        } catch (error) {
            console.error('Error exporting jobs:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There was a problem with the download");
            }
            setLoadingFilter(false);
        }
    };

    return (
        <section className='lightBabyGreen baseHeightWidth customScroll'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            {/* PageBanner => used to show page banner info */}
            <PageBanner pageName='Interview Schedule' pageTitle='Ready to start your day' src='/img/registration.png' alt="Interview Schedule" />
            {/* view details of interview */}
            {interviewModal && 
            (<InterviewScheduleModal
                data={formData}
                onChange={handleChangeInput}
                onClose={handleClose}
                onCancel={handleCancelEdit}
                OnlyView={!user[index]?.edit_access}
                onEdit={handleEditOn}
                onSubmit={handleSubmit}
                loading={loading === "4"}
                errors={errors} 
                disabled={!interviewEdit}
            />)
            }
            {/* View and edit candidate info */}
            {viewCandidate && 
                (<EditCandidate 
                onChange={handleChangeInput}
                onCancel={handleCancelCandidateEdit}
                onClose={handleClose}
                onSubmit={handleCandidateSubmit}
                onEdit={handleEditOn}
                OnlyView={true}
                data={formData}
                onDownload={handleDownload}
                loading={loadingUpdate}
                errors={errors}
                disabled={!candidateEdit}
                />)
            }
            {jobFormModal && (
                <JobPost 
                data={jobData} 
                disabled 
                // onChange={handleChange} 
                // onCancel={handleCancel}
                onClose={handleClose} 
                // onEdit={handleJobEdit}
                // onSubmit={handleSubmit}
                // onlyView={!user[index]?.edit_access}
                onlyView
                // onAddQuestions={handleAddQuestion}
                extraQuestions={extraQuestions}
                // onDeleteQuestion={handleDeleteQuestion}
                // onChangeQuestions={handleChangeQuestion}
                // errors={errors}
                // handleSubmitUpdate = {handleSubmitUpdate}
                // loading={loading === "2"}
                />
            )}
            {/* show position wise details */}
            {positionWiseView &&
                (<PositionWiseData rows={positionWiseData} usersOption={usersOption}
                filter={positionFilter} pagination={paginationPositionList} loading={loading === "3"} loadingFilter={loadingFilter === "3"} loadingClear={loadingFilter === "4"}
                onChangeFilter={handleChangePositionFilter} onClose={handleClose} onRefresh={handleRefreshPosition} onFilter={handlePositionFilter}
                onFilterClear={handlePositionClear} onPositionCheck={handlePositionCheck} onPositionSelect={handlePositionSelect} onSort={handleSort} onLimit={handleLimitPositionList}
                onPrev={handlePrevPositionList} onNext={handleNextPositionList}
                />)
            }
            {/* filters */}
            <div className='grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl'>
                <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                value={filterData?.fromDate}
                onChange={handleChangeFilter}
                />
                <InputField  id="toDate" name="toDate" type="date" label="To:"
                value={filterData?.toDate}
                onChange={handleChangeFilter}
                />
                <InputField  id="candidate" name="candidate" type="text" label="Candidate:"
                placeholder="Enter Candidate"
                value={filterData?.candidate}
                onChange={handleChangeFilter}
                />
                <InputField  id="company" name="company" type="text" label="Company:"
                placeholder="Enter Company"
                value={filterData?.company}
                onChange={handleChangeFilter}
                />
                <InputField  id="position" name="position" type="text" label="Position:"
                placeholder="Enter Position"
                value={filterData?.position}
                onChange={handleChangeFilter}
                />
                {localStorage.getItem("role") === "Recruiter" ? null : 
                    (<Dropdown  id="recruiter"  name="recruiter"  label="Recruiter:"
                        onChange={handleChangeFilter}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        placeholder={`Select Recruiter`}
                        value={filterData?.recruiter}
                        options={usersOption}
                        search={true} // to enable search input
                        checkBox={true} // to enable checkbox
                        checkValue={filterData?.isActive} // to make checkbox check and uncheck
                        onCheck={handleCheck} // to make changes in list of options onChange  
                    />)
                }
                <Dropdown id="interview_status" name="interview_status" label="Interview Status:"
                    onChange={handleChangeFilter}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    placeholder={`All`}
                    value={filterData?.interview_status}
                    options={allInterviewStatusOptions}
                />
                <div className="flex gap-3 col-span-1">
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                        <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.interview_status && !filterData?.recruiter)} 
                        loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                        <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.interview_status && !filterData?.recruiter)} 
                        loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                        <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter } 
                        loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Position Details</label>
                        <BasicButton onClick={handlePositionModal} buttonName='Position Details' className="bg-purple-700 text-nowrap" shadow={true}
                        disabled={loading} 
                        rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-purple-900" />
                    </div>
                </div>

            </div>
            {/* candidate interview deatils table */}
            <div className=' mt-5'>
                { loading === "1" ?
                    <Loader height='w-[48dvh]' /> :
                    Array.isArray(allInterviews) && allInterviews?.length >= 1 ?
                    <section className='tableWrapper'>
                        <div className='tableBody'>
                            {/* candidate interview deatils table */}
                            <table className='w-full table-fixed border-collapse'>
                                <thead className='tableHead'>
                                    <tr className=' text-left'>
                                        {/* <th className='whitespace-nowrap text-center w-[5%]' >Sr.No.</th> */}
                                        <th className='whitespace-nowrap text-center w-[16%]'>
                                            <div onClick={() => handleInterviewSort("scheduled_date")} className='flex item-center gap-0 pr-2 justify-center w-full cursor-pointer'>
                                                Scheduled Date
                                                {filterData?.orderBy === "scheduled_date" && filterData?.orderDirection === "ASC" ?
                                                <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                filterData?.orderBy === "scheduled_date" && filterData?.orderDirection === "DESC" ?
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                            </div>
                                        </th>
                                        <th className=' whitespace-nowrap'>
                                            <div onClick={() => handleInterviewSort("candidate")} className='flex item-center gap-0 pr-8 w-full cursor-pointer'>
                                                Candidate
                                                {filterData?.orderBy === "candidate" && filterData?.orderDirection === "ASC" ?
                                                <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                filterData?.orderBy === "candidate" && filterData?.orderDirection === "DESC" ?
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                            </div>

                                        </th>
                                        <th className=' whitespace-nowrap' >
                                             <div onClick={() => handleInterviewSort("position")} className='flex item-center gap-0 pr-8 w-full cursor-pointer'>
                                               Position
                                                {filterData?.orderBy === "position" && filterData?.orderDirection === "ASC" ?
                                                <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                filterData?.orderBy === "position" && filterData?.orderDirection === "DESC" ?
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                            </div>
                                            
                                        </th>
                                        <th className='whitespace-nowrap text-center w-[20%]'>Interview Status</th>
                                        <th className=' text-center w-[9%]'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className='tableBody '>
                                    {
                                        Array.isArray(allInterviews) && allInterviews?.map((val, idx) => {
                                            return (
                                                <tr key={val?.id} id={val?.id} className='font-semibold text-sm text-left'>
                                                    {/* <td className='text-center' >{idx + 1}</td> */}
                                                    <td>
                                                        <span className='line-clamp-1 text-ellipsis'>{val?.scheduled_date ? formatDate(val?.scheduled_date) : "--"}</span>
                                                        {localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ? null : 
                                                        (<span className='line-clamp-1 text-ellipsis text-green-600'>{val?.Candidate?.User?.name}</span>)}
                                                    </td>
                                                    <td className=' whitespace-nowrap'>
                                                        <span className={`line-clamp-1 text-ellipsis text-blue-900 ${val?.Candidate?.candidate && (user[index]?.view_access || user[index]?.edit_access) && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> {if (user[index]?.view_access || user[index]?.edit_access) handleEdit(val)}}>{val?.Candidate?.candidate || "--"}</span>
                                                        {/* <span className='line-clamp-1 text-ellipsis'>{val?.Candidate?.candidate || "--"}</span> */}
                                                        <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.Candidate?.candidate_email ? val?.Candidate?.candidate_email : "NA"}</span>
                                                    </td>
                                                    <td className=' ' >
                                                        <span className='whitespace-nowrap line-clamp-1 text-ellipsis' >{val?.Candidate?.Position?.Company.company_name}</span>
                                                        <span className={`line-clamp-1 text-ellipsis text-[0.9vw] text-blue-900 ${val?.Candidate?.Position?.position && (user[index]?.view_access) && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> {if (user[index]?.view_access) handleViewJob(val)}}>{val?.Candidate?.Position?.position}</span>
                                                    </td>        
                                                    <td className='text-center'>
                                                        {
                                                            handleCheckStatus(val?.interview_status) ?
                                                            <h3 className={`whitespace-nowrap line-clamp-1 text-ellipsis w-full text-center rounded-lg text-nowrap outline-none border border-gray-300 py-2.5 px-1 ${handleCheckStatus(val?.interview_status)?.className}`}>
                                                                {handleCheckStatus(val?.interview_status)?.name}
                                                            </h3> :
                                                            <Dropdown id="interview_status"  name="interview_status" 
                                                                onChange={(e) => { handleStatusChange(e,val); }}
                                                                className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                                placeholder={`Select Status`}
                                                                value={val?.interview_status}
                                                                options={interviewStatusOptions}
                                                                disabled={!user[index]?.edit_access}
                                                            />
                                                        }
                                                    </td>
                                                    <td>
                                                        <div className='flex justify-center items-center gap-2'>
                                                            {localStorage.getItem("role") === "Recruiter" ? null : 
                                                            <RevertStatusButton data={val} onClick={()=> handleRevertStatus(val)} tooltipName="Revert Status" disabled={val?.candidate_status === "Sent To Client" || !user[index]?.edit_access} />}
                                                            <InterviewButton data={val} onClick={()=> handleInterview(val)} tooltipName="Interview Details" disabled={!user[index]?.edit_access && !user[index]?.view_access} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )    
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        {/* pagination of table */}
                        <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                        limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                        disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                        />
                    </section> :
                    // if interview data not found then show this div
                    <NoRecords/>
                }
            </div>
        </section>
    );
}

export default InterviewSchedule;